// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"f7afd036","480":"0d0fbb26","838":"88428572"}[chunkId] + ".js";
};